import React from 'react';

export const SharepointVideoIcon = (): React.JSX.Element => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M2.5 14H13.5C13.77 14 14 13.77 14 13.5V2.5C14 2.22 13.77 2 13.5 2H2.5C2.22 2 2 2.22 2 2.5V13.5C2 13.77 2.22 14 2.5 14Z"
			fill="white"
		/>
		<path
			opacity="0.64"
			d="M13.5 15H2.5C1.67 15 1 14.33 1 13.5V2.5C1 1.67 1.67 1 2.5 1H13.5C14.33 1 15 1.67 15 2.5V13.5C15 14.33 14.33 15 13.5 15ZM2.5 2C2.37 2 2.24 2.05 2.15 2.15C2.05 2.24 2 2.37 2 2.5V13.5C2 13.63 2.05 13.76 2.15 13.85C2.24 13.95 2.37 14 2.5 14H13.5C13.63 14 13.76 13.95 13.85 13.85C13.95 13.76 14 13.63 14 13.5V2.5C14 2.37 13.95 2.24 13.85 2.15C13.76 2.05 13.63 2 13.5 2H2.5Z"
			fill="#605E5C"
		/>
		<path
			d="M10.5 8L6.5 5.5V10.5L10.5 8Z"
			stroke="#69AFE5"
			strokeMiterlimit="10"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
